module.exports = __webpack_public_path__ + "img/34_BF12_bamboo_shelter.9e87bf4a.jpg";